var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedInOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m49.76,31.74c-4.64,0-7.88,2.96-7.88,7.19s3.17,7.07,7.88,7.07,7.89-2.84,7.89-7.07-3.24-7.19-7.89-7.19Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "32.54 53.53 32.54 62.22 44.52 62.22 44.52 94.26 56.15 94.26 56.15 53.53 32.54 53.53",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.09,52.52c-5.22,0-9.79,2.04-14.36,6.43l-.14.14h-.97l-.91-5.56h-9.37v40.73h11.63v-27.56l.16-.15c2.97-2.84,5.39-4.48,8.95-4.48,4.79,0,6.74,2.47,6.74,8.52v23.67h11.63v-25.27c0-10.93-4.49-16.47-13.36-16.47Z",
    style: {
      fill: "#d65e38"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m120.51,70.92v43.75H16.49v-43.75H1.98v58.25h133.03v-58.25h-14.5Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.98,1.83v55.66h14.51V16.33h104.02v41.15h14.5V1.83H1.98Z",
    style: {
      fill: "#d65e38"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInOrange);
export default __webpack_public_path__ + "static/media/LinkedIn.Orange.ba2f4d1260f77f507db90080eb565310.svg";
export { ForwardRef as ReactComponent };